// extracted by mini-css-extract-plugin
export default {"userWrapper":"User_userWrapper__QrH-o","card":"User_card__A2aFK","table":"User_table__uTuRc","changePassBtn":"User_changePassBtn__l7rj4"};